/**
 * Green Flag — PinnedBottomBar
 *
 * The bar pinned to the bottom of the event page: the "Get Tickets" bar for
 * someone who can register, and the check-in bar once they hold a seat.
 * Children are laid out in one row, spaced apart.
 */

import { Box, Flex } from "@chakra-ui/react";
import { ReactNode } from "react";

export interface PinnedBottomBarProps {
  children: ReactNode;
}

export function PinnedBottomBar({ children }: PinnedBottomBarProps) {
  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      bg="bg.canvas"
      borderTop="1px solid"
      borderColor="border.default"
      px="1.25rem"
      py="0.75rem"
      zIndex={900}
    >
      <Flex
        maxW="58rem"
        mx="auto"
        align="center"
        justify="space-between"
        gap="1rem"
      >
        {children}
      </Flex>
    </Box>
  );
}
